(function (global) {
  'use strict';

  var OV_LANG = (global.document && global.document.documentElement && global.document.documentElement.lang) || 'nl';

  // Locale table for strings this file writes into the DOM at runtime.
  // Keyed on document.documentElement.lang; anything not 'fr' falls back to
  // the original nl copy, so Dutch behaviour stays bit-identical.
  var OV_STRINGS = {
    quantityAdjustRegion: { nl: 'Aantal aanpassen', fr: 'Ajuster la quantité' },
    quantityDecrease: { nl: 'Eén minder', fr: 'Diminuer la quantité' },
    quantityIncrease: { nl: 'Eén meer', fr: 'Augmenter la quantité' },
    quantityValuePrefix: { nl: 'Aantal ', fr: 'Quantité ' },
    remove: { nl: 'Verwijderen', fr: 'Supprimer' },
    cartTriggerLabelPrefix: { nl: 'Winkelwagen (', fr: 'Panier (' },
    cartEmptyBody: { nl: 'Uw winkelwagen is nog leeg.', fr: 'Votre panier est vide.' },
    cartEmptyStatus: { nl: 'Uw winkelwagen is leeg.', fr: 'Votre panier est vide.' },
    cartUpdatedStatus: { nl: 'Uw winkelwagen is bijgewerkt.', fr: 'Votre panier a été mis à jour.' },
    cartLoadingStatus: { nl: 'Uw winkelwagen wordt geladen.', fr: 'Votre panier se charge.' },
    cartUpdatingStatus: { nl: 'Uw winkelwagen wordt bijgewerkt.', fr: 'Votre panier se met à jour.' },
    cartAddingStatus: { nl: 'Uw keuze wordt toegevoegd.', fr: 'Ajout de votre choix en cours.' },
    cartAddedStatus: { nl: 'Toegevoegd aan uw winkelwagen.', fr: 'Ajouté à votre panier.' },
    loadCartError: { nl: 'Uw winkelwagen kon niet worden geladen. Probeer het opnieuw.', fr: 'Une erreur s\'est produite. Veuillez réessayer.' },
    addProductError: { nl: 'Toevoegen is niet gelukt. Probeer het opnieuw.', fr: 'Une erreur s\'est produite. Veuillez réessayer.' },
    changeLineError: { nl: 'Aanpassen is niet gelukt. Probeer het opnieuw.', fr: 'Une erreur s\'est produite. Veuillez réessayer.' }
  };

  function ovText(key) {
    var entry = OV_STRINGS[key];
    if (!entry) return '';
    return entry[OV_LANG] || entry.nl;
  }

  function cartEndpoints(shopRoot) {
    var root = (shopRoot || '/').replace(/\/+$/, '') || '';
    return {
      add: root + '/cart/add.js',
      cart: root + '/cart.js',
      change: root + '/cart/change.js'
    };
  }

  function formatMoney(cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    return '€' + (amount / 100).toFixed(2).replace('.', ',');
  }

  function readError(payload, fallback) {
    if (payload && typeof payload === 'object') {
      if (typeof payload.description === 'string' && payload.description) return payload.description;
      if (typeof payload.message === 'string' && payload.message) return payload.message;
    }
    return fallback;
  }

  async function responseJson(response, fallback) {
    var payload;
    try { payload = await response.json(); } catch (ignore) { throw new Error(fallback); }
    if (!response.ok) throw new Error(readError(payload, fallback));
    return payload;
  }

  async function loadCart(fetchImpl, shopRoot) {
    var response = await fetchImpl(cartEndpoints(shopRoot).cart, {
      headers: { Accept: 'application/json' }
    });
    return responseJson(response, ovText('loadCartError'));
  }

  async function addProduct(form, fetchImpl, shopRoot) {
    var response = await fetchImpl(cartEndpoints(shopRoot).add, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new global.FormData(form)
    });
    await responseJson(response, ovText('addProductError'));
    return loadCart(fetchImpl, shopRoot);
  }

  async function changeLine(key, quantity, fetchImpl, shopRoot) {
    var response = await fetchImpl(cartEndpoints(shopRoot).change, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    });
    return responseJson(response, ovText('changeLineError'));
  }

  function createCartController(options) {
    options = options || {};
    var queue = Promise.resolve();
    var pendingCount = 0;
    var onConfirmedCart = typeof options.onConfirmedCart === 'function' ? options.onConfirmedCart : function () {};
    var onError = typeof options.onError === 'function' ? options.onError : function () {};
    var onPendingChange = typeof options.onPendingChange === 'function' ? options.onPendingChange : function () {};

    function enqueue(operation) {
      pendingCount += 1;
      onPendingChange(true);
      queue = queue.then(operation, operation).then(function (cart) {
        onConfirmedCart(cart);
        return cart;
      }, function (error) {
        onError(error);
        throw error;
      }).finally(function () {
        pendingCount -= 1;
        onPendingChange(pendingCount > 0);
      });
      return queue;
    }

    return {
      add: function (form) {
        return enqueue(function () { return addProduct(form, options.fetchImpl, options.shopRoot); });
      },
      change: function (key, quantity) {
        return enqueue(function () { return changeLine(key, quantity, options.fetchImpl, options.shopRoot); });
      },
      refresh: function () {
        return enqueue(function () { return loadCart(options.fetchImpl, options.shopRoot); });
      },
      pending: function () { return pendingCount > 0; }
    };
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function element(document, tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function setButtonData(button, name, value) {
    button.setAttribute(name, '');
    button.setAttribute('data-key', value.key || '');
    button.setAttribute('data-quantity', String(value.quantity));
  }

  function lineImage(document, item) {
    if (!item.image) return null;
    var image = element(document, 'img', 'ov-store-cart-image');
    image.src = item.image;
    image.alt = '';
    image.width = 164;
    image.height = 184;
    image.loading = 'lazy';
    return image;
  }

  function lineMarkup(document, item) {
    var article = element(document, 'article', 'ov-store-cart-line');
    article.setAttribute('data-ov-cart-line', '');
    var image = lineImage(document, item);
    if (image) article.appendChild(image);
    else article.appendChild(element(document, 'div', 'ov-store-cart-image'));

    var body = element(document, 'div', 'ov-store-cart-line-body');
    body.appendChild(element(document, 'h3', '', item.product_title || item.title || 'Product'));
    if (item.variant_title && item.variant_title !== 'Default Title') {
      body.appendChild(element(document, 'p', 'ov-store-cart-variant', item.variant_title));
    }
    var properties = item.properties && typeof item.properties === 'object' ? item.properties : {};
    var propertyNames = Object.keys(properties).filter(function (name) {
      return name.charAt(0) !== '_' && properties[name] !== null && properties[name] !== '';
    });
    if (propertyNames.length) {
      var propertyList = element(document, 'div', 'ov-store-cart-properties');
      propertyNames.forEach(function (name) {
        propertyList.appendChild(element(document, 'span', 'ov-store-cart-property', name + ': ' + properties[name]));
      });
      body.appendChild(propertyList);
    }
    var linePrice = element(document, 'p', 'ov-store-cart-price', formatMoney(item.final_line_price));
    linePrice.setAttribute('data-ov-cart-line-price', '');
    body.appendChild(linePrice);

    var actions = element(document, 'div', 'ov-store-cart-line-actions');
    var quantity = element(document, 'div', 'ov-store-cart-quantity');
    quantity.setAttribute('aria-label', ovText('quantityAdjustRegion'));
    var decrease = element(document, 'button', '', '−');
    decrease.type = 'button';
    decrease.setAttribute('aria-label', ovText('quantityDecrease'));
    setButtonData(decrease, 'data-ov-cart-quantity', { key: item.key, quantity: item.quantity - 1 });
    var output = element(document, 'output', '', item.quantity);
    output.setAttribute('aria-label', ovText('quantityValuePrefix') + item.quantity);
    output.setAttribute('data-ov-cart-line-quantity', '');
    var increase = element(document, 'button', '', '+');
    increase.type = 'button';
    increase.setAttribute('aria-label', ovText('quantityIncrease'));
    setButtonData(increase, 'data-ov-cart-quantity', { key: item.key, quantity: item.quantity + 1 });
    quantity.appendChild(decrease);
    quantity.appendChild(output);
    quantity.appendChild(increase);
    actions.appendChild(quantity);

    var remove = element(document, 'button', 'ov-store-cart-remove', ovText('remove'));
    remove.type = 'button';
    remove.setAttribute('data-ov-cart-remove', '');
    remove.setAttribute('data-key', item.key || '');
    remove.setAttribute('data-quantity', '0');
    actions.appendChild(remove);
    body.appendChild(actions);
    article.appendChild(body);
    return article;
  }

  function updateCounts(root, count) {
    var nodes = root.querySelectorAll('[data-ov-cart-count]');
    for (var index = 0; index < nodes.length; index += 1) {
      nodes[index].textContent = String(count || 0);
    }
    var triggers = root.querySelectorAll('[data-ov-cart-open]');
    for (var triggerIndex = 0; triggerIndex < triggers.length; triggerIndex += 1) {
      triggers[triggerIndex].setAttribute('aria-label', ovText('cartTriggerLabelPrefix') + (count || 0) + ')');
    }
  }

  function renderCart(root, drawer, cart) {
    var document = drawer.ownerDocument;
    var items = drawer.querySelector('[data-ov-cart-items]');
    var summary = drawer.querySelector('[data-ov-cart-summary]');
    var total = drawer.querySelector('[data-ov-cart-total]');
    var checkoutTotal = drawer.querySelector('[data-ov-cart-checkout-total]');
    if (!items || !summary || !total || !checkoutTotal) return;
    clear(items);
    var lines = Array.isArray(cart.items) ? cart.items : [];
    var confirmedTotal = formatMoney(cart.total_price);
    total.textContent = confirmedTotal;
    checkoutTotal.textContent = confirmedTotal;
    if (!lines.length) {
      var empty = element(document, 'p', 'ov-store-cart-empty', ovText('cartEmptyBody'));
      empty.setAttribute('data-ov-cart-empty', '');
      items.appendChild(empty);
      summary.hidden = true;
    } else {
      for (var index = 0; index < lines.length; index += 1) items.appendChild(lineMarkup(document, lines[index]));
      summary.hidden = false;
    }
    updateCounts(root, cart.item_count);
  }

  function init(root) {
    if (!root || root.getAttribute('data-ov-store-initialized') === 'true') return root;
    root.setAttribute('data-ov-store-initialized', 'true');
    var document = root.ownerDocument || global.document;
    var drawer = document && document.querySelector('[data-ov-cart-drawer]');
    if (!drawer || typeof global.fetch !== 'function' || typeof global.FormData !== 'function') return root;
    var panel = drawer.querySelector('[role="dialog"]');
    var status = drawer.querySelector('[data-ov-cart-status]');
    var lastFocus = null;
    var fetchImpl = global.fetch.bind(global);
    var shopRoot = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    var confirmedCart = null;

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message || '';
      status.setAttribute('data-error', isError ? 'true' : 'false');
    }

    function showDrawer(opener) {
      lastFocus = opener || document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-cart-open');
      if (panel && panel.focus) panel.focus();
    }

    function closeDrawer() {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-cart-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function setCartBusy(isBusy) {
      if (panel) panel.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      var controls = drawer.querySelectorAll('[data-ov-cart-quantity], [data-ov-cart-remove]');
      for (var index = 0; index < controls.length; index += 1) controls[index].disabled = isBusy;
    }

    function dispatchCartUpdate(cart) {
      if (!root.dispatchEvent || typeof global.CustomEvent !== 'function') return;
      root.dispatchEvent(new global.CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { cart: cart }
      }));
    }

    var controller = createCartController({
      fetchImpl: fetchImpl,
      shopRoot: shopRoot,
      onConfirmedCart: function (cart) {
        confirmedCart = cart;
        renderCart(root, drawer, cart);
        dispatchCartUpdate(cart);
      },
      onError: function (error) {
        if (confirmedCart) renderCart(root, drawer, confirmedCart);
        setStatus(error.message, true);
      },
      onPendingChange: setCartBusy
    });

    async function refresh(opener) {
      showDrawer(opener);
      setStatus(ovText('cartLoadingStatus'), false);
      try {
        var cart = await controller.refresh();
        setStatus(cart.item_count ? ovText('cartUpdatedStatus') : ovText('cartEmptyStatus'), false);
        return cart;
      } catch (error) {
        return null;
      }
    }

    var openers = root.querySelectorAll('[data-ov-cart-open]');
    for (var openerIndex = 0; openerIndex < openers.length; openerIndex += 1) {
      openers[openerIndex].addEventListener('click', function (event) {
        event.preventDefault();
        refresh(event.currentTarget);
      });
    }

    var closers = drawer.querySelectorAll('[data-ov-cart-close]');
    for (var closeIndex = 0; closeIndex < closers.length; closeIndex += 1) {
      closers[closeIndex].addEventListener('click', closeDrawer);
    }

    drawer.addEventListener('click', async function (event) {
      var control = event.target.closest && event.target.closest('[data-ov-cart-quantity], [data-ov-cart-remove]');
      if (!control) return;
      event.preventDefault();
      if (controller.pending()) return;
      setStatus(ovText('cartUpdatingStatus'), false);
      try {
        var cart = await controller.change(control.getAttribute('data-key'), control.getAttribute('data-quantity'));
        setStatus(cart.item_count ? ovText('cartUpdatedStatus') : ovText('cartEmptyStatus'), false);
      } catch (error) {
        return;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (drawer.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab' || !panel) return;
      var focusable = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var forms = root.querySelectorAll('form[data-v2t-form], form[data-ov-cart-form]');
    for (var formIndex = 0; formIndex < forms.length; formIndex += 1) {
      forms[formIndex].addEventListener('submit', async function (event) {
        event.preventDefault();
        if (controller.pending()) return;
        var form = event.currentTarget;
        var submitters = form.querySelectorAll('[type="submit"]');
        for (var index = 0; index < submitters.length; index += 1) submitters[index].disabled = true;
        showDrawer(event.submitter || form);
        setStatus(ovText('cartAddingStatus'), false);
        try {
          await controller.add(form);
          setStatus(ovText('cartAddedStatus'), false);
        } catch (error) {
        } finally {
          for (var submitIndex = 0; submitIndex < submitters.length; submitIndex += 1) submitters[submitIndex].disabled = false;
        }
      });
    }

    if (global.Shopify && global.Shopify.actions && typeof global.Shopify.actions === 'object') {
      global.Shopify.actions.getCart = function () { return controller.refresh(); };
      global.Shopify.actions.openCart = function () {
        showDrawer(document.activeElement);
        setStatus(ovText('cartLoadingStatus'), false);
        return controller.refresh().then(function (cart) {
          setStatus(cart.item_count ? ovText('cartUpdatedStatus') : ovText('cartEmptyStatus'), false);
          return cart;
        });
      };
    }
    var genericVariants = root.querySelectorAll('[data-ov-generic-variant]');
    for (var variantIndex = 0; variantIndex < genericVariants.length; variantIndex += 1) {
      genericVariants[variantIndex].addEventListener('change', function (event) {
        var choice = event.currentTarget;
        var form = choice.closest('form');
        var cents = Number(choice.getAttribute('data-price'));
        var price = formatMoney(cents);
        var priceNode = root.querySelector('[data-ov-generic-price]');
        var buttonPrice = form && form.querySelector('[data-ov-generic-button-price]');
        if (priceNode) priceNode.textContent = price;
        if (buttonPrice) buttonPrice.textContent = price;
      });
    }
    return root;
  }

  global.OVStore = {
    init: init,
    cartEndpoints: cartEndpoints,
    formatMoney: formatMoney,
    loadCart: loadCart,
    addProduct: addProduct,
    changeLine: changeLine,
    createCartController: createCartController
  };

  function initialize() {
    var root = global.document && global.document.querySelector('[data-v2-store], [data-v2-trust]');
    init(root);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  }
})(globalThis);
